var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGIantMobileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74109 12.1716C7.77754 12.1829 7.81651 12.1829 7.85296 12.1716C7.88204 12.1811 7.91336 12.1811 7.94245 12.1716L19.2072 5.68349C19.7982 5.41803 20.4387 5.28078 21.0866 5.28078C21.7344 5.28078 22.3749 5.41803 22.9659 5.68349L34.2195 12.1828C34.2485 12.2046 34.2838 12.2164 34.3202 12.2164C34.3565 12.2164 34.3918 12.2046 34.4208 12.1828L38.5039 8.82689C38.5158 8.8025 38.5219 8.77572 38.5219 8.74859C38.5219 8.72146 38.5158 8.69468 38.5039 8.67028C38.5026 8.64325 38.4949 8.61693 38.4812 8.59355C38.4676 8.57018 38.4485 8.55045 38.4256 8.53605L25.5947 1.11941C24.225 0.365849 22.6833 -0.0195824 21.1201 0.000765888C19.5572 -0.0175477 18.016 0.367756 16.6455 1.11941L3.6804 8.55842C3.65656 8.57287 3.63618 8.59238 3.62071 8.61558C3.60525 8.63877 3.59507 8.66509 3.59091 8.69266C3.59003 8.72044 3.59564 8.74805 3.60729 8.77329C3.61894 8.79854 3.63631 8.82072 3.65803 8.83808L7.74109 12.1716Z",
    fill: "url(#paint0_linear_3087_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4183 17.7535C27.436 17.7609 27.455 17.7647 27.4742 17.7647C27.4934 17.7647 27.5124 17.7609 27.5302 17.7535L31.3224 14.6325C31.3588 14.5929 31.3787 14.5409 31.3783 14.4871C31.377 14.4601 31.3693 14.4337 31.3556 14.4104C31.342 14.387 31.3229 14.3673 31.3 14.3529L23.3576 9.81115C22.652 9.44718 21.8695 9.25726 21.0756 9.25726C20.2816 9.25726 19.4991 9.44718 18.7935 9.81115L10.8399 14.3529C10.817 14.3673 10.7979 14.387 10.7843 14.4104C10.7707 14.4337 10.7629 14.4601 10.7616 14.4871C10.7562 14.5141 10.7586 14.5422 10.7685 14.5679C10.7784 14.5937 10.7954 14.6161 10.8176 14.6325L14.6322 17.7088C14.6612 17.7306 14.6965 17.7424 14.7328 17.7424C14.7691 17.7424 14.8045 17.7306 14.8335 17.7088L20.9861 14.1962C21.015 14.1796 21.0478 14.1708 21.0812 14.1708C21.1145 14.1708 21.1473 14.1796 21.1762 14.1962L27.3288 17.72L27.4183 17.7535Z",
    fill: "url(#paint1_linear_3087_20)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7799 25.3828L21.0196 27.8327H21.1091H21.1986L25.3712 25.4164C25.3986 25.4006 25.4213 25.3777 25.4371 25.3502C25.4528 25.3227 25.4609 25.2915 25.4606 25.2598V20.4384C25.4609 20.4067 25.4528 20.3755 25.4371 20.348C25.4213 20.3205 25.3986 20.2976 25.3712 20.2818L21.2545 17.8991C21.2277 17.8822 21.1967 17.8732 21.165 17.8732C21.1334 17.8732 21.1023 17.8822 21.0755 17.8991L17.5966 19.9015L16.9142 20.2371C16.8829 20.249 16.8562 20.2706 16.838 20.2988C16.8199 20.327 16.8113 20.3602 16.8135 20.3937V23.9062L16.7576 25.2486C16.751 25.2712 16.7495 25.295 16.7534 25.3183C16.7573 25.3415 16.7664 25.3636 16.7799 25.3828Z",
    fill: "url(#paint2_linear_3087_20)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4285 44.993C18.5593 45.5642 19.8084 45.8618 21.0753 45.8618C22.3422 45.8618 23.5913 45.5642 24.7221 44.993C25.3374 44.6574 37.6425 37.6099 37.6425 37.6099C38.9945 36.7949 40.1154 35.6475 40.8986 34.2768C41.6818 32.9062 42.1013 31.3579 42.1171 29.7794V14.9126C42.1158 14.884 42.1081 14.8561 42.0945 14.8309C42.081 14.8057 42.0619 14.7839 42.0388 14.7671C42.0142 14.756 41.9875 14.7503 41.9605 14.7503C41.9335 14.7503 41.9068 14.756 41.8822 14.7671L36.9489 16.6353C36.9332 16.6557 36.9221 16.6792 36.9163 16.7043C36.9105 16.7294 36.9102 16.7555 36.9154 16.7807C36.9154 16.7807 36.9154 29.6675 36.9154 30.0031C36.8196 30.6111 36.6043 31.1941 36.2817 31.7183C35.9591 32.2426 35.5357 32.6976 35.036 33.057L22.9658 40.0038C22.373 40.2695 21.7306 40.4069 21.0809 40.4069C20.4312 40.4069 19.7889 40.2695 19.196 40.0038L7.15934 33.057C6.65969 32.6976 6.23631 32.2426 5.91372 31.7183C5.59113 31.1941 5.37574 30.6111 5.28001 30.0031C5.2129 29.6675 5.28001 16.7807 5.28001 16.7807C5.27969 16.7463 5.26878 16.7128 5.24877 16.6848C5.22876 16.6567 5.20061 16.6356 5.16815 16.6241L0.234916 14.7559C0.210308 14.7448 0.183614 14.7391 0.156611 14.7391C0.129607 14.7391 0.102913 14.7448 0.0783053 14.7559C0.0551591 14.7727 0.0360981 14.7945 0.0225406 14.8197C0.00898322 14.8449 0.00127854 14.8728 0 14.9014L0 29.8017C0.0157713 31.3803 0.435226 32.9286 1.21845 34.2992C2.00167 35.6699 3.12261 36.8173 4.47459 37.6323C4.47459 37.6323 16.7126 44.6238 17.4285 44.993Z",
    fill: "url(#paint3_linear_3087_20)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8939 35.9317C19.5691 36.2758 20.3173 36.4523 21.0752 36.4463C21.8301 36.4578 22.576 36.2809 23.2454 35.9317L31.322 31.3229C32.0246 30.9516 32.6076 30.3889 33.0036 29.6999C33.3995 29.011 33.5922 28.2239 33.5593 27.43V18.3242C33.558 18.2956 33.5503 18.2677 33.5368 18.2425C33.5232 18.2173 33.5042 18.1955 33.481 18.1788C33.4564 18.1676 33.4297 18.1619 33.4027 18.1619C33.3757 18.1619 33.349 18.1676 33.3244 18.1788L28.7156 19.9015C28.6831 19.9129 28.655 19.9341 28.635 19.9621C28.6149 19.9902 28.604 20.0237 28.6037 20.0581V27.1056C28.6062 27.1333 28.6 27.1611 28.586 27.1852C28.5719 27.2092 28.5508 27.2283 28.5254 27.2398L21.0417 31.4571C20.9731 31.4828 20.8976 31.4828 20.8291 31.4571L13.4572 27.2398C13.4319 27.2283 13.4107 27.2092 13.3967 27.1852C13.3826 27.1611 13.3764 27.1333 13.3789 27.1056V20.0581C13.3786 20.0237 13.3677 19.9902 13.3477 19.9621C13.3277 19.9341 13.2995 19.9129 13.2671 19.9015L8.74772 18.1676C8.72311 18.1564 8.69642 18.1507 8.66942 18.1507C8.64241 18.1507 8.61572 18.1564 8.59111 18.1676C8.56796 18.1844 8.5489 18.2062 8.53535 18.2313C8.52179 18.2565 8.51408 18.2844 8.51281 18.313V27.4076C8.47856 28.2018 8.67068 28.9894 9.06678 29.6786C9.46288 30.3678 10.0467 30.9303 10.7501 31.3005L18.8939 35.9317Z",
    fill: "url(#paint4_linear_3087_20)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3087_20",
    x1: 3.59091,
    y1: 6.10858,
    x2: 38.5598,
    y2: 6.10858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#53B947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3087_20",
    x1: 209.119,
    y1: 111.942,
    x2: 589.549,
    y2: 111.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#53B947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3087_20",
    x1: 146.782,
    y1: 221.345,
    x2: 214.977,
    y2: 221.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76BF43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#53B947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28B24B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3087_20",
    x1: 0,
    y1: 30.3051,
    x2: 42.1618,
    y2: 30.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A6B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#535455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3087_20",
    x1: 199.17,
    y1: 464.758,
    x2: 762.134,
    y2: 464.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6A6B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#535455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIantMobileLogo);
export default __webpack_public_path__ + "static/media/GIantMobileLogo.c96bed9bd776944921ca8edbb946ce2a.svg";
export { ForwardRef as ReactComponent };